<template>
  <div class="exam-uniform-schedule-append">
    <template v-if="batchInfo">
      <div class="label">
        <span>考试开放时间：</span>
        <template v-if="batchInfo.examQueryStartDate && batchInfo.examQueryEndDate">
          <span>{{batchInfo.examQueryStartDate}}</span>
          <span>至</span>
          <span>{{batchInfo.examQueryEndDate}}</span>
        </template>
        <template v-else>
          <span>未设置</span>
        </template>
      </div>
      <div :class="['state', {'is-publish': batchInfo.isPublish}]">
        <div class="label">
          <template v-if="batchInfo.isPublish">
            <i class="el-icon-success"></i>
            <span>已发布</span>
          </template>
          <template v-else>
            <i class="el-icon-warning"></i>
            <span>未发布</span>
          </template>
        </div>
        <div v-if="!batchInfo.isPublish"
             class="extra">
          <el-button size="mini"
                     type="primary"
                     :loading="committing"
                     @click="handlePublish">{{committing ? '发布中...' : '发布考试'}}</el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="loading">
        <span class="loading">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </span>
      </template>
      <template v-else>
        <span class="load-err">
          <span>批次信息加载失败</span>
          <el-button size="mini"
                     type="text"
                     @click="loadBatchInfo">重新加载</el-button>
        </span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ExamUniformScheduleAppend',
  props: {
    batchId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      batchInfo: null,
      committing: false
    }
  },
  methods: {
    loadBatchInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/exam/uniform/schedule/batchInfo',
        method: 'post',
        data: this.$qs.stringify({
          batchId: this.batchId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.batchInfo = response.data['batchInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handlePublish () {
      this.$confirm('请确认考场编排工作已完成再进行考试发布，学生将收到考试信息，是否继续操作？', '提示', {
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/exam/uniform/schedule/setPublish',
          method: 'post',
          data: this.$qs.stringify({
            batchId: this.batchId
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.loadBatchInfo()
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.loadBatchInfo()
  },
  activated () {
    this.loadBatchInfo()
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../styles/color";
  .exam-uniform-schedule-append {
    margin-left: 15px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    & > .label {
      font-size: 12px;
    }
    & > .state {
      margin-left: 15px;
      color: $set-warning-color;
      font-size: 12px;
      display: flex;
      align-items: center;
      &.is-publish {
        color: $set-success-color;
      }
      & > .extra {
        margin-left: 10px;
        .el-button {
          padding: 5px 12px;
        }
      }
    }
    .loading,
    .load-err {
      font-size: 12px;
    }
  }
</style>
